<template>
  <div id="game-view">
    <chat-window :socket="socket"></chat-window>

    <div id="game-logistics">
      ping: {{ ping }}ms
    </div>

    <div v-if="!attempted || !connected">
      attempted: {{ attempted }}, connected: {{ connected }}
    </div>
  </div>
</template>

<script>
import { io } from 'socket.io-client';
import ChatWindow from "@/components/ChatWindow.vue"

const socket = io();

export default {
  components: { ChatWindow },
  name: 'GameView',
  data () {
    return {
      socket: socket,
      ping: 0,
      gameID: '',
      attempted: false,
      connected: false
    }
  },
  methods: {
    getPing () {
      const start = Date.now();
      this.socket.emit('ping', () => {
        this.ping = Date.now() - start;
      });
    },
    connectToGame () {
      this.socket.emit('connect-to-game', this.gameID);
      this.attempted = true;
    }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search);
    const gameID = params.get('id');
    this.gameID = gameID;

    this.getPing();
    setInterval(() => {
      this.getPing();
    }, 1000);

    this.connectToGame();

    this.socket.on('connect', () => {
      console.log('socket connected');
    });

    this.socket.on('join-game', () => {
      this.connected = true;
    });
  },
  beforeUnmount () {
    this.socket.disconnect();
  }
}
</script>

<style scoped>
#game-logistics {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 16px;
  left: 16px;
}
</style>